<template>
  <a-row style="height: 600px">
    <a-col :span="24">
      <a-tabs defaultActiveKey="esdate">
        <a-tab-pane tab="成立时间" key="esdate" forceRender>
          <div id="esdate" style="width: 800px; height: 500px;"></div>
        </a-tab-pane>

        <a-tab-pane tab="注册地区" key="province" forceRender>
          <div id="province" style="width: 800px; height: 500px;"></div>
        </a-tab-pane>

        <a-tab-pane tab="行业分类" key="industry" forceRender>
          <div id="industry" style="width: 800px; height: 500px;"></div>
        </a-tab-pane>

        <a-tab-pane tab="注册资金" key="reged_cap" forceRender>
          <div id="reged_cap" style="width: 800px; height: 500px;"></div>
        </a-tab-pane>

        <!-- a-tab-pane tab="注册资金" key="haha" forceRender>
          <div id="haha" style="width: 800px; height: 500px;"></div>
        </a-tab-pane -->
      </a-tabs>
    </a-col>
  </a-row>
</template>

<script>
let china = require('echarts/map/js/china.js');

/*let anhui = require('echarts/map/js/province/anhui.js');
let aomen = require('echarts/map/js/province/aomen.js');
let beijing = require('echarts/map/js/province/beijing.js');
let chongqing = require('echarts/map/js/province/chongqing.js');
let fujian = require('echarts/map/js/province/fujian.js');
let gansu = require('echarts/map/js/province/gansu.js');
let guangdong = require('echarts/map/js/province/guangdong.js');
let guangxi = require('echarts/map/js/province/guangxi.js');
let guizhou = require('echarts/map/js/province/guizhou.js');
let hainan = require('echarts/map/js/province/hainan.js');
let hebei = require('echarts/map/js/province/hebei.js');
let henan = require('echarts/map/js/province/henan.js');
let heilongjiang = require('echarts/map/js/province/heilongjiang.js');
let hubei = require('echarts/map/js/province/hubei.js');
let hunan = require('echarts/map/js/province/hunan.js');
let jiangsu = require('echarts/map/js/province/jiangsu.js');
let jiangxi = require('echarts/map/js/province/jiangxi.js');
let jilin = require('echarts/map/js/province/jilin.js');
let liaoning = require('echarts/map/js/province/liaoning.js');
let neimenggu = require('echarts/map/js/province/neimenggu.js');
let ningxia = require('echarts/map/js/province/ningxia.js');
let qinghai = require('echarts/map/js/province/qinghai.js');
let shandong = require('echarts/map/js/province/shandong.js');
let shanghai = require('echarts/map/js/province/shanghai.js');
let shanxi = require('echarts/map/js/province/shanxi.js');
let sichuan = require('echarts/map/js/province/sichuan.js');
let taiwan = require('echarts/map/js/province/taiwan.js');
let tianjin = require('echarts/map/js/province/tianjin.js');
let xianggang = require('echarts/map/js/province/xianggang.js');
let xinjiang = require('echarts/map/js/province/xinjiang.js');
let xizang = require('echarts/map/js/province/xizang.js');
let yunnan = require('echarts/map/js/province/yunnan.js');
let zhejiang = require('echarts/map/js/province/zhejiang.js');*/


export default {
  name: 'entstatistic',
  data() {
    return {
    }
  },
  props: {
   statistic: {}
  },
  mounted() {
    this.showStats();
  },
  watch: {
    statistic: function(newvalue, oldvalue) {
      this.statistic = newvalue;
      this.showStats();
    }
  },
  methods: {
    showStats: function() {
      this.drawDate();
      this.drawLocation();
      this.drawIndustry();
      this.drawRegedCap();
    },
    drawDate: function() {
      let myChart = this.echarts.init(document.getElementById("esdate"));
      let x = this.statistic["esdate"].x;
      let y = this.statistic["esdate"].y;
      x.splice(0, 1);
      y.splice(0, 1);
      let start = 0;
      for (let i = 0; i < y.length; i++) {
        if (y[i] > 0) {
          break;
        } else {
          start += 1;
        }
      }
      x.splice(0, start);
      y.splice(0, start);
      myChart.setOption({
        title: {
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: x
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [{
          type: 'line',
          data: y,
          smooth: true
        }]
      });
    },
    drawLocation: function() {
      let x = this.statistic["province"].x;
      let y = this.statistic["province"].y;
      let provinceData = [];
      let sum = 0;
      let max = 0;
      for (let i = 0; i < y.length; i++) {
        if (x[i]) {
          let provinceName = "";
          let length = x[i].split(/[省|市]/g).length;
          if (length > 1) {
            provinceName = x[i].split(/[省|市]/g)[0];
          } else {
            let prefix = x[i].substring(0, 2);
            if (prefix == "内蒙") {
              prefix = "内蒙古";
            }
            provinceName = prefix;
          }
          provinceData.push({name: provinceName, value: y[i]});
          sum += y[i];
          if (y[i] > max)
            max = y[i];
        }
      }
      let myChart = this.echarts.init(document.getElementById("province"));
      myChart.setOption({
        tooltip: {
          show: true,
          formatter: function(params) {
            return params.name + '：' + (params.data ? params.data['value'] : 0)
          },
        },
         visualMap: {
           type: 'continuous',
           text: ['', ''],
           showLabel: true,
           seriesIndex: [0],
           min: 0,
           max: max,
           inRange: {
             color: ['#fffbe6', '#fff1b8', '#ffe58f', '#ffd666', '#ffc53d', '#faad14', '#d48806', '#ad6800']
           },
           textStyle: {
             color: '#000'
           },
           bottom: 30,
           left: 'left',
        },
        series: [{
          type: 'map',
          map: 'china',
          roam: true,
          itemStyle: {
            normal: {
              label: {
                show: true,
                color: 'rgba(0, 0, 0, 0.65)'
              }
            },
            emphasis: {
              label: {
                show: true
              }
            }
          },
          data: provinceData
        }]
      });
    },
    drawIndustry: function() {
      let myChart = this.echarts.init(document.getElementById("industry"));
      let x = this.statistic["industry"].x;
      let y = this.statistic["industry"].y;
      let pieData = [];
      for (let i = 0; i < x.length; i++) {
        pieData.push({value: y[i], name: x[i]});
      }

      myChart.setOption({
        title: {
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          data: x
        },
        series: [
          {
            name: '行业',
            type: 'pie',
            radius: '55%',
            center: ['50%', '70%'],
            data: pieData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    drawRegedCap: function() {
      let myChart = this.echarts.init(document.getElementById("reged_cap"));
      myChart.setOption({
        color: ['#1890ff', 'red'],
        title: {
        },
        tooltip: {},
        xAxis: {
          name: '万元',
          type: 'category',
          data: this.statistic["reged_cap"].x,
          axisLabel: {
            interval: 0,
            rotate: 20
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [{
          type: 'bar',
          data: this.statistic["reged_cap"].y,
          barWidth: '50%'
        }]
      });
    }
  },
  created() {
  }
}
</script>

<style scoped>
</style>

